exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".periode-section[data-v-d7b4c86e]{margin-bottom:15px;padding:10px}.periode-title[data-v-d7b4c86e]{font-weight:700;margin-bottom:8px;font-size:18px}.rekap-table[data-v-d7b4c86e]{width:100%;border-collapse:collapse;font-size:13px}.rekap-table td[data-v-d7b4c86e],.rekap-table th[data-v-d7b4c86e]{border:1px solid #ccc;padding:6px 8px;text-align:left}.rekap-table th[data-v-d7b4c86e]{background-color:#e8f5e9;background-color:green}.periode-total td[data-v-d7b4c86e]{background-color:#f0f0f0;font-weight:700}", ""]);

// exports
